'use strict';
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024 from "./com.raquo.airstream.core.-Airstream-Error$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1 from "./scala.scalajs.runtime.-Anon-Function1.$$-Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_airstream_core_Transaction$() {
  this.uJ = 0;
  this.DI = null;
  $n_Lcom_raquo_airstream_core_Transaction$ = this;
  this.uJ = 1000;
  this.DI = new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((trx) => {
    throw $j_java$002elang$002e$002dObject.$ct_jl_Exception__T__(new $j_java$002elang$002e$002dObject.$c_jl_Exception(), (("Attempted to run Transaction " + trx) + " after it was already executed."));
  }));
}
export { $c_Lcom_raquo_airstream_core_Transaction$ as $c_Lcom_raquo_airstream_core_Transaction$ };
$p = $c_Lcom_raquo_airstream_core_Transaction$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_core_Transaction$;
/** @constructor */
function $h_Lcom_raquo_airstream_core_Transaction$() {
}
export { $h_Lcom_raquo_airstream_core_Transaction$ as $h_Lcom_raquo_airstream_core_Transaction$ };
$h_Lcom_raquo_airstream_core_Transaction$.prototype = $p;
$p.Ob = (function(transaction) {
  try {
    transaction.ym.j(transaction);
    var x = transaction.rA;
    if ((x !== (void 0))) {
      while (((x.iC.length | 0) !== 0)) {
        if (((x.iC.length | 0) === 0)) {
          throw $j_java$002elang$002e$002dObject.$ct_jl_Exception__T__(new $j_java$002elang$002e$002dObject.$c_jl_Exception(), "Unable to dequeue an empty JsPriorityQueue");
        }
        x.iC.shift().XX(transaction);
      }
    }
  } catch (e) {
    var e$2 = ((e instanceof $j_java$002elang$002e$002dObject.$c_jl_Throwable) ? e : new $j_java$002elang$002e$002dObject.$c_sjs_js_JavaScriptException(e));
    $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024.$m_Lcom_raquo_airstream_core_AirstreamError$().eb(e$2);
  }
});
var $d_Lcom_raquo_airstream_core_Transaction$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_core_Transaction$, "com.raquo.airstream.core.Transaction$", ({
  gR: 1
}));
export { $d_Lcom_raquo_airstream_core_Transaction$ as $d_Lcom_raquo_airstream_core_Transaction$ };
var $n_Lcom_raquo_airstream_core_Transaction$;
function $m_Lcom_raquo_airstream_core_Transaction$() {
  if ((!$n_Lcom_raquo_airstream_core_Transaction$)) {
    $n_Lcom_raquo_airstream_core_Transaction$ = new $c_Lcom_raquo_airstream_core_Transaction$();
  }
  return $n_Lcom_raquo_airstream_core_Transaction$;
}
export { $m_Lcom_raquo_airstream_core_Transaction$ as $m_Lcom_raquo_airstream_core_Transaction$ };
